// extracted by mini-css-extract-plugin
export var box = "_8p-1";
export var checked = "_8p-2";
export var descriptionSpacer = "_8p-9";
export var disabled = "_8p-3";
export var icon = "_8p-6";
export var input = "_8p-0";
export var labelSpacer = "_8p-8";
export var medium = "_8p-5";
export var small = "_8p-4";
export var text = "_8p-7";